export default {
  filters: {
    managers: {
      placeholder: 'Salgschefer',
    },
  },
  metrics: {
    collected_commission: 'Samlet provision',
  },
  fields: {
    manager: 'Chef',
    area: 'Område',
    total_amount: 'Indtjening',
    companies_live: 'Live',
    restaurant: 'Restaurant',
    live_from: 'Live siden',
    plan_amount: 'Abonnementsbeløb',
    prepayment_bonus_amount: 'Forudbetalingsbonus',
    lead_source_bonus_amount: 'Bonus for leadkilde',
    google_business_bonus_amount: 'Bonus for Google Business-forbindelse',
    promo_code_bonus_amount: 'Bonus for master-kampagnekode',
    smart_pricing_bonus_amount: 'Smart pricing-bonus',
    mobile_app_bonus_amount: 'Mobilapp-bonus',
    sales_goal_bonus_amount: 'Salgsmålsbonus',
  },
  buttons: {
    export: 'Eksportér',
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
  },
};
